import { childQuestions } from "../data/child-questions";
import {
  CalculationInputDto,
  Region,
  FamilyInput,
  ChildInput,
  Handicap,
  Income,
} from "../models/calculation-api.types";
import { CalculatorField } from "../models/CalculatorStep";
import { FamilyFormState } from "./../models/FamilyFormState";

export function calculationMapper(
  family: FamilyFormState,
  children: FamilyFormState[]
): CalculationInputDto {
  const region = mapRegion(family.Region || "");
  return {
    region: region,
    family: mapFamily(family),
    children: mapChildren(children, region),
  };
}

export function mapRegion(region: string): Region {
  region = (region || "").toLowerCase();

  if (region.match("vlaanderen|flanders|fla")?.length) {
    return Region.Flanders;
  }
  if (region.match("walloni|wallonia|wallo")?.length) {
    return Region.Wallonia;
  }
  if (region.match("brussel|bruxelles|bru")?.length) {
    return Region.Brussels;
  }

  throw new Error(`unable to map region: ${region}`);
}

function mapFamily(family: FamilyFormState): FamilyInput {
  return {
    income: family.GrossIncome as Income,
    isLangdurigZiek: mapYesNo(family.SickParent),
    isSingleParent: family.FamilySituation === "single",
  };
}

function mapChildren(
  children: FamilyFormState[],
  region: Region
): ChildInput[] {
  return children.map((child) => ({
    name: child.ChildName || "",

    dateOfBirth: mapDate(child.ChildBirthdate || ""),

    isInOldSystem: enabled(child, CalculatorField.ChildOldSystem, region)
      ? child.ChildOldSystem === 'old'
      : false,

    isOrphan: enabled(child, CalculatorField.ChildHasDeadParents, region)
      ? mapYesNo(child.ChildHasDeadParents)
      : false,

    IsOrphanBeforeMilestone: enabled(child, CalculatorField.ChildOrphanAfter2018, region)
      ? mapYesNo(child.ChildOrphanAfter2018) === false : false,

    areBothParentsDeceased: enabled(
      child,
      CalculatorField.ChildOneOrBothParentsDead,
      region
    )
      ? child.ChildOneOrBothParentsDead === "two"
      : false,

    handicap: enabled(child, CalculatorField.ChildHandicap, region)
      ? parseInt(child.ChildHandicap || "0")
      : Handicap.None,
  }));
}

function mapYesNo(input: string | undefined): boolean {
  return input?.toLowerCase() === "true";
}

function mapDate(datestring: string) {
  return new Date(datestring).toISOString().split("T")[0];
}

function enabled(
  child: FamilyFormState,
  field: CalculatorField,
  region: Region
): boolean {
  var method = childQuestions.find((q) => q.field === field)?.visible;
  if (!method) {
    return true;
  }

  return method(child, region);
}
